module.exports = __webpack_public_path__ + "static/media/NEX.dcc80e1f.png";